import React from 'react';
import backgroundVideo from '../../assets/Video/istockphoto-1371917992-640_adpp_is.mp4';

export const HeroHome = () => {
  return (
    <section className="HeroSection bg-white overflow-hidden w-full mx-auto flex items-center justify-center pt-[113px] max-w-[1920px] 2xl:max-w-[3840px]">
      <div className="relative w-full h-[700px] md:h-[800px] xl:h-[900px] 2xl:h-[992px] flex items-center justify-center">
        {/* Background Video */}
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 w-full h-full object-cover"
        >
          <source src={backgroundVideo} type="video/mp4" loading="lazy" />
          Your browser does not support the video tag.
        </video>

        {/* Gradient Overlay */}
        <div
          className="absolute inset-0"
          style={{
            background: 'linear-gradient(245deg, rgba(0, 0, 0, 0) 23.99%, #000 99.36%)',
            mixBlendMode: 'multiply',
          }}
        />

        {/* Text Content */}
        <div className="relative z-20 flex flex-col gap-6 items-center px-4 md:px-8 text-center max-w-[90%] sm:max-w-[80%] md:max-w-[70%] xl:max-w-[60%] 2xl:max-w-[50%]">
          {/* Heading */}
          <div className="text-[36px] sm:text-[48px] lg:text-[64px] 2xl:text-[72px] font-bold leading-tight">
            <span className="text-white">Design To Deliver</span>
            <br />
            <span className="text-[#5bc0fe]">An EPC Company</span>
          </div>

          {/* Description */}
          <div className="text-white text-[16px] sm:text-[18px] md:text-[20px] lg:text-[22px] leading-[150%]">
            We specialize in innovative and creative modern infrastructures that redefine architecture with style and functionality.
          </div>

          {/* Optional Button */}
          {/* <button
            onClick={() => (window.location.href = "/Contact")}
            className="bg-white text-[#5bc0fe] px-[32px] py-[12px] rounded-full flex items-center justify-center hover:bg-[#FFD700] hover:text-[#3E4343] transition-colors duration-300"
          >
            <span className="text-[18px] sm:text-[20px] font-medium">
              Contact Us
            </span>
          </button> */}
        </div>
      </div>
    </section>
  );
};

export default HeroHome;
